module.exports = __webpack_public_path__ + "static/media/xtra-big.424110e8.png";